"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSSR = void 0;

var isSSR = function () {
  try {
    return !(document !== undefined);
  } catch (e) {
    return true;
  }
}();

exports.isSSR = isSSR;